<template>
  <li
    v-on:click="toggle"
    v-bind:class="{ active: isActive, inactive: isInactive }"
    v-wave="{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}"
  >
    {{ name }}
  </li>
</template>

<script>
import { Flow } from "../services/flow";

export default {
  name: "ConfiguratorStepExtrasItem",
  props: ["option", "item"],
  data: function() {
    return {};
  },
  computed: {
    name: function() {
      return this.item.name;
    },
    isActive: function() {
      if (this.$store.state.selected[this.option] !== null) {
        return (
          this.$store.state.selected[this.option].indexOf(this.item.id) >= 0
        );
      } else if (this.item.checked) {
        return this.item.checked;
      } else {
        return false;
      }
    },
    isInactive: function() {
      return this.$store.state.step != this.option;
    }
  },
  methods: {
    toggle: function() {
      this.$store.commit("toggleOption", {
        name: this.option,
        value: this.item.id
      });
    }
  }
};
</script>

<style scoped>
li {
  padding: 7px 30px;
  margin: 0 5px;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

li:hover {
  background: #eee;
}

li.inactive {
  color: #888;
}

li.active {
  color: #54a324;
}

li:after {
  content: "\E835";
  font-family: "Material Icons";
  font-size: 16px;
  line-height: 32px;
  position: absolute;
  left: 5px;
  top: 1px;
}

li.active:after {
  content: "\E834";
  font-family: "Material Icons";
  font-size: 16px;
  line-height: 32px;
  position: absolute;
  left: 5px;
  top: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepExtrasItem.vue